import React from "react";
import { faSquare, faSquareMinus } from "@fortawesome/pro-regular-svg-icons";
import { faSquareCheck } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
var Checkbox = function (_a) {
    var id = _a.id, name = _a.name, checked = _a.checked, _b = _a.indeterminate, indeterminate = _b === void 0 ? false : _b, onChange = _a.onChange, onIndeterminateChange = _a.onIndeterminateChange, label = _a.label, helpText = _a.helpText, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.required, required = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? "medium" : _e, _f = _a.className, className = _f === void 0 ? "" : _f, value = _a.value, tabIndex = _a.tabIndex;
    var handleClick = function () {
        if (!disabled) {
            if (indeterminate) {
                // If indeterminate, first click makes it checked
                onChange(true);
                if (onIndeterminateChange) {
                    onIndeterminateChange(false);
                }
            }
            else {
                // Normal toggle behavior
                onChange(!checked);
            }
        }
    };
    var handleKeyDown = function (e) {
        if (e.key === " " || e.key === "Enter") {
            e.preventDefault();
            handleClick();
        }
    };
    // Determine the icon to display
    var getIcon = function () {
        if (indeterminate)
            return faSquareMinus;
        if (checked)
            return faSquareCheck;
        return faSquare;
    };
    // Determine the state class
    var getStateClass = function () {
        if (indeterminate)
            return "lib-checkbox-indeterminate";
        return checked ? "lib-checkbox-checked" : "lib-checkbox-unchecked";
    };
    var wrapperClasses = [
        "lib-checkbox-wrapper",
        "lib-checkbox-".concat(size),
        disabled ? "lib-checkbox-disabled" : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");
    return (React.createElement("div", null,
        React.createElement("div", { className: wrapperClasses, onClick: handleClick, onKeyDown: handleKeyDown, role: "checkbox", "aria-checked": indeterminate ? "mixed" : checked, "aria-disabled": disabled, "aria-required": required, tabIndex: disabled ? -1 : (tabIndex !== null && tabIndex !== void 0 ? tabIndex : 0) },
            React.createElement("div", { className: "lib-checkbox-icon" },
                React.createElement(FontAwesomeIcon, { icon: getIcon(), className: getStateClass() })),
            label && (React.createElement("span", { className: "lib-checkbox-label" },
                label,
                required && React.createElement("span", { className: "lib-checkbox-required" }, "*")))),
        helpText && React.createElement("div", { className: "lib-checkbox-help" }, helpText),
        React.createElement("input", { id: id, name: name, type: "checkbox", checked: checked, onChange: function () { }, disabled: disabled, value: value, style: { display: "none" }, "aria-hidden": "true", tabIndex: -1 })));
};
export default Checkbox;
